module.exports = __webpack_public_path__ + "img/input-cursor.8dc3dd53.svg";